import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import GTManager from '@widgets/gtm';
import SentryManager from '@widgets/sentry-manager';
import { authActions } from '@actions';
import { authService } from '@services';
import { useQueryParams } from '@hooks';
import { RoutePath } from '@constants/routes';

const CreateAccountViaStripe = () => {
    const dispatch = useDispatch();
    const query = useQueryParams();
    const history = useHistory();

    const createAccountViaStripe = async () => {
        const sessionId = query.get('checkout_session_id');
        try {
            const user = await authService.createAccountViaStripe({ sessionId });
            GTManager.update(user);
            SentryManager.setUser(user);
            dispatch(authActions.setUser(user));
            history.push(RoutePath.Onboarding);
        } catch (_) {
            history.push(RoutePath.Login);
        }
    };

    useEffect(() => {
        createAccountViaStripe();
    }, []);

    return <div />;
};

export default CreateAccountViaStripe;
